// extracted by mini-css-extract-plugin
module.exports = {"root":"ChoroplethConfig_root__3TzNo","field":"ChoroplethConfig_field__WXzjE","label":"ChoroplethConfig_label__1iDU3","fieldSelect":"ChoroplethConfig_fieldSelect__3Ke8d"};